import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.sort.js";
import { createSelector } from 'reselect';
import { applicationSelector, applicationNotes, notesFilterSelector } from '@applyboard/ab-common';
import { sortByDateCreated } from "../../util/common";
var privateNoteMarker = 'private';
var otherApplicationsMap = createSelector(applicationSelector, function (application) {
  return application.otherApplications && application.otherApplications.byIndex;
});
var otherApplicationsIndexes = createSelector(applicationSelector, function (application) {
  return application.otherApplications.availableIndexes;
});
export var applicationNotesArray = createSelector(applicationNotes, function (notes) {
  return notes ? notes.availableIndexes.map(function (idx) {
    return notes.byIndex[idx];
  }) : [];
});
export var publicNotes = createSelector(applicationNotesArray, function (noteList) {
  return noteList.filter(function (note) {
    return note.visibility.toLowerCase() !== privateNoteMarker;
  });
});
export var privateNotes = createSelector(applicationNotesArray, function (noteList) {
  return noteList.filter(function (note) {
    return note.visibility.toLowerCase() === privateNoteMarker;
  });
});
export var applicationStudentIdSelector = createSelector(applicationSelector, function (application) {
  return application && application.application && application.application.student && application.application.student.student_id;
});
export var applicationOldStudentIdSelector = createSelector(applicationSelector, function (application) {
  var _application$applicat, _application$applicat2;
  return application === null || application === void 0 ? void 0 : (_application$applicat = application.application) === null || _application$applicat === void 0 ? void 0 : (_application$applicat2 = _application$applicat.student) === null || _application$applicat2 === void 0 ? void 0 : _application$applicat2.id;
});
export var applicationOtherApplicationsLoadingSelector = createSelector(applicationSelector, function (application) {
  return application.otherApplications ? application.otherApplications.loading : false;
});
export var applicationOtherApplicationsSelector = createSelector(otherApplicationsMap, otherApplicationsIndexes, function (othersMap, indexes) {
  return othersMap ? indexes.map(function (id) {
    return othersMap[id];
  }) : [];
});
export var applicationTabSelected = createSelector(applicationSelector, function (application) {
  return application === null || application === void 0 ? void 0 : application.currentTab;
});
export var rowloadingSelector = createSelector(applicationSelector, function (application) {
  return application.rowloading;
});
export var notesListSelector = createSelector(applicationNotes, notesFilterSelector, function (notes, filter) {
  var list = notes.availableIndexes.map(function (index) {
    return notes.byIndex[index];
  });
  if (filter === 'internal') {
    list = list.filter(function (x) {
      return x.visibility !== 'public';
    });
  } else if (filter === 'public') {
    list = list.filter(function (x) {
      return x.visibility !== 'private';
    });
  }
  return list.sort(sortByDateCreated).reverse();
});
// eslint-disable-line @typescript-eslint/no-explicit-any
export var notesTotalCount = createSelector(applicationNotes, function (notes) {
  return notes ? notes.availableIndexes.length : 0;
});
export var showAppReqCountSelector = createSelector(applicationSelector, function (application) {
  return application.showAppReqCount;
});
export var showActionsCountSelector = createSelector(applicationSelector, function (application) {
  return application.showActionsCount;
});
export var appReqCountSelector = createSelector(applicationSelector, function (application) {
  return application.appReqCount;
});
export var actionsCountSelector = createSelector(applicationSelector, function (application) {
  return application.actionsCount;
});
export var notesPublicTotalCount = createSelector(publicNotes, function (notes) {
  return notes ? notes.length : 0;
});
export var notesPrivateTotalCount = createSelector(privateNotes, function (notes) {
  return notes ? notes.length : 0;
});
export var applicationIsModifiedSelector = createSelector(applicationSelector, function (state) {
  return state.application && state.application.is_modified || false;
});
export var selectedPreviewRequirementFileIdSelector = createSelector(applicationSelector, function (application) {
  return application.selectedPreviewRequirementFileId;
});
export var selectedPreviewRequirementIdSelector = createSelector(applicationSelector, function (application) {
  return application.selectedPreviewRequirementId;
});

// TODO(new-rq-modal): remember to remove this after new modal is merged
export var applicationCreatingRequirementSelector = createSelector(applicationSelector, function (application_state) {
  return application_state.creating_requirement;
});
export var applicationEditingRequirementSelector = createSelector(applicationSelector, function (application_state) {
  return application_state.editing_requirement_id;
});
export var applicationOtherApplicationsLoadedSelector = createSelector(applicationSelector, function (application) {
  return application.otherApplications ? application.otherApplications.loaded : false;
});